const RE_STRIP_NON_ALPHA = /[^\w]/g;

// TODO: Rename to "nameToCanonicalName".
// TODO: Check for name collision.
// TODO: Make sure starts with letter. (Lang-specific?)
export function nodeNameToFactoryId(
  nodeName: string
): string {
  return nodeName.replace(RE_STRIP_NON_ALPHA, "_");
}
